import script from "./ModalCorte.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCorte.vue?vue&type=script&setup=true&lang=js"

import "./ModalCorte.vue?vue&type=style&index=0&id=79593438&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79593438"]])

export default __exports__